import type { SearchPagination, SearchResponse } from '@algolia/client-search';

import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import {
  findSsrApiDataUrl,
  getSsrApiDataForUrl,
} from 'rendering/state/ssrApiData';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

import type { CmsApiPage } from './types/CmsApiPage';
import type { CmsApiRedirect } from './types/CmsApiRedirect';
import type { CmsApiSearchLandingPage } from './types/CmsApiSearchLandingPage';
import type { CmsApiPageSlug } from './types/CmsApiTypedId';

type ApiResponse = {
  data: CmsApiPage | CmsApiRedirect | CmsApiSearchLandingPage;
  type: string;
};

function mapResponse(
  response: ApiResponse,
): CmsApiPage | CmsApiRedirect | CmsApiSearchLandingPage {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (slug: CmsApiPageSlug) => `/data/website/contents/${slug}`,
  mapResponse,
});

// Exports

export const cmsApiFetchPage = endpoint.createFetchFn();

export const cmsApiHorizonFetchPage = endpoint.createHorizonFetchFn();

// Landing Page SSR

type SsrApiDataForSearchLandingPage = {
  data: CmsApiSearchLandingPage;
  ssrLandingPageResults: SearchResponse<SearchAlgoliaHit> &
    Required<SearchPagination>;
  type: string;
};

export function cmsApiGetFetchLandingPageSsrApiData():
  | SsrApiDataForSearchLandingPage
  | undefined {
  const ssrApiDataUrl = findSsrApiDataUrl((url, ssrApiData) =>
    Boolean(
      url.startsWith('/data/website/contents/') &&
        typeof ssrApiData === 'object' &&
        ssrApiData &&
        'ssrLandingPageResults' in ssrApiData,
    ),
  );

  return getSsrApiDataForUrl<SsrApiDataForSearchLandingPage>(ssrApiDataUrl);
}
